import $ from 'jquery'
import {ReportGroupingLevel} from '../constants'
import BudgetedVsActualReportEditConfigController from './BudgetedVsActualReportEditConfigController'

export default class BudgetedVsActualEditFormConfigController extends BudgetedVsActualReportEditConfigController {}

BudgetedVsActualEditFormConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    let result = $.extend({}, reportParameters)

    if (!EnabledFeatures.BTY) {
        const groupings = this.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel(
            ReportGroupingLevel.BILLING_TYPE,
            [result.firstGroupingLevel, result.secondGroupingLevel, result.thirdGroupingLevel],
            ReportGroupingLevel.CUSTOMER,
        )
        result.firstGroupingLevel = groupings[0]
        result.secondGroupingLevel = groupings[1]
        result.thirdGroupingLevel = groupings[2]
    }
    return result
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/BudgetedVsActualEditFormConfigController.js